// import React, { useState } from "react";
// import { Box, Typography, IconButton, Avatar } from "@mui/material";
// import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

// const TEAMMEMBER = [
//   {
//     image: require("../../assets/images/About/About-Two.png"),
//     name: "Sameer Madan",
//     position: "Director",
//     linkedinUrl: "https://www.linkedin.com/in/sameer-madan-2204aba/",
//     description:
//       "Sameer is a calm and decisive operations leader who balances profit, growth, and team harmony with a laser focus on customer satisfaction. With deep operational insight and wisdom, he leads from the front, navigating even the toughest business climates with clarity and confidence. ",
//   },

//   {
//     image: require("../../assets/images/About/About-Four.png"),
//     name: "Ankur Aggarwal",
//     position: "Chief Finance Officer",
//     linkedinUrl:
//       "https://www.linkedin.com/in/ankagarwal/?original_referer=https%3A%2F%2Facrossassist.com%2F ",
//     description:
//       "Ankur is a strategic financial leader with a deep understanding of the tech and financial services sectors. He brings sharp decision-making, global business insight, and risk evaluation expertise to every table. As CFO, his precision drives growth and financial resilience.",
//   },

//   {
//     image: require("../../assets/images/About/About-Five.png"),
//     name: "Ankur Sawhney",
//     position: "Head of Automobile Busines",
//     linkedinUrl: "https://www.linkedin.com/in/ankur-sawhney-49229616/",
//     description:
//       "With 14+ years across Sales, Claims, Product Strategy, and UW in the Health, Travel, and Personal Accident domains, Ankur is a true auto industry insider. He’s the driving force behind streamlined operations and customer-centric innovations in the automobile vertical. ",
//   },

//   {
//     image: require("../../assets/images/About/About-Seven.png"),
//     name: "Mayank Mishra",
//     position: "Head of Mobile Business",
//     linkedinUrl: "https://www.linkedin.com/in/mayank-mishra-46326a23/",
//     description:
//       "Mayank is a retail and telecom veteran with over 22 years of experience in franchisee management, Retail, sales strategy, and channel leadership. Known for his execution excellence and team-building acumen, Mayank’s ability to connect authentically has made him a pioneer in appliance and gadgets networking. ",
//   },

//   {
//     image: require("../../assets/images/About/About-Three.png"),
//     name: "Atul Sharma",
//     position: "Head – Technology ",
//     linkedinUrl: "https://www.linkedin.com/in/atul-sharma-meta-insurance/",
//     description:
//       "Atul brings 12 years of rich experience across product innovation, customer engagement, and SaaS delivery. A hands-on experience in tech strategy, he’s known for building scalable B2B/B2C solutions and fostering agile transformation.",
//   },
// ];

// const ProfileSlider = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const handleNext = () => {
//     setCurrentIndex((prev) => (prev + 1) % TEAMMEMBER.length);
//   };

//   const handlePrev = () => {
//     setCurrentIndex(
//       (prev) => (prev - 1 + TEAMMEMBER.length) % TEAMMEMBER.length
//     );
//   };

//   const { name, position, image, description } = TEAMMEMBER[currentIndex];

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         // flexWrap: "wrap", // allow wrapping on smaller screens
//         px: { xs: 2, sm: 4 },
//         // px: 4,
//         py: 8,
//         bgcolor: "#f9f4f2",
//         gap: 2,
//         // minHeight: "100vh",
//         flexDirection: "row", // keep horizontal layout always
//         flexWrap: "nowrap", // prevent wrapping
//         overflow: "hidden",
//       }}
//     >
//       <IconButton onClick={handlePrev}>
//         <ArrowBackIos sx={{ color: "#FF8C00" }} />
//       </IconButton>

//       <Box
//         sx={{
//           // width: "660px", // Fixed width to match name and keep layout stable
//           textAlign: "center",
//           // px: 15,
//           px: { xs: 0, sm: 0, md: 5, lg: 15 },
//         }}
//       >
//         <Box
//           sx={{
//             mb: 1,
//             mx: "auto",
//             width: 200,
//             height: 200,
//             overflow: "hidden",
//             borderRadius: "50%",
//             backgroundColor: "#13452b",
//             border: "4px solid transparent",
//             background: "linear-gradient(93.14deg, #FF8C00, #FF4500)",
//           }}
//         >
//           <Avatar
//             src={image}
//             alt={name}
//             sx={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//             }}
//           />
//         </Box>

//         <Typography
//           variant="h5"
//           sx={{
//             fontWeight: 600,
//             color: "black",
//             fontFamily: '"Poppins",serif',
//             fontSize: { xs: "1rem", sm: "1.rem", md: "1.25rem" },
//           }}
//         >
//           {name}
//         </Typography>

//         <Typography
//           variant="subtitle1"
//           sx={{
//             mt: -0.5,
//             mb: 1,
//             color: "gray",
//             fontFamily: '"Poppins",serif',
//             fontSize: { xs: "0.82rem", sm: "0.82rem", md: "0.9rem" },
//           }}
//         >
//           {position}
//         </Typography>

//         {/* <Box
//           component="hr"
//           sx={{
//             width: 80,
//             height: 4,
//             backgroundColor: "#c4d600",
//             border: "none",
//             mx: "auto",
//             my: 2,
//           }}
//         /> */}

//         <Typography
//           variant="body2"
//           sx={{
//             whiteSpace: "pre-line",
//             color: "#444",
//             textAlign: "justify",
//             fontFamily: '"Poppins",serif',
//             fontSize: { xs: "0.82rem", sm: "0.82rem", md: "0.9rem" },
//             width: { xs: "435px", sm: "435px", md: "700px" },
//           }}
//         >
//           {description}
//         </Typography>
//       </Box>

//       <IconButton onClick={handleNext}>
//         <ArrowForwardIos sx={{ color: "#FF8C00" }} />
//       </IconButton>
//     </Box>
//   );
// };

// export default ProfileSlider;

import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { Box, Avatar, Container, IconButton, Typography } from "@mui/material";

const TEAMMEMBER = [
  {
    image: require("../../assets/images/About/About-Two.png"),
    name: "Sameer Madan",
    position: "Director",
    linkedinUrl: "https://www.linkedin.com/in/sameer-madan-2204aba/",
    description:
      "Sameer is a calm and decisive operations leader who balances profit, growth, and team harmony with a laser focus on customer satisfaction. With deep operational insight and wisdom, he leads from the front, navigating even the toughest business climates with clarity and confidence. ",
  },

  {
    image: require("../../assets/images/About/About-Four.png"),
    name: "Ankur Aggarwal",
    position: "Chief Finance Officer",
    linkedinUrl:
      "https://www.linkedin.com/in/ankagarwal/?original_referer=https%3A%2F%2Facrossassist.com%2F ",
    description:
      "Ankur is a strategic financial leader with a deep understanding of the tech and financial services sectors. He brings sharp decision-making, global business insight, and risk evaluation expertise to every table. As CFO, his precision drives growth and financial resilience.",
  },

  {
    image: require("../../assets/images/About/About-Five.png"),
    name: "Ankur Sawhney",
    position: "Head of Automobile Busines",
    linkedinUrl: "https://www.linkedin.com/in/ankur-sawhney-49229616/",
    description:
      "With 14+ years across Sales, Claims, Product Strategy, and UW in the Health, Travel, and Personal Accident domains, Ankur is a true auto industry insider. He’s the driving force behind streamlined operations and customer-centric innovations in the automobile vertical. ",
  },

  {
    image: require("../../assets/images/About/About-Seven.png"),
    name: "Mayank Mishra",
    position: "Head of Mobile Business",
    linkedinUrl: "https://www.linkedin.com/in/mayank-mishra-46326a23/",
    description:
      "Mayank is a retail and telecom veteran with over 22 years of experience in franchisee management, Retail, sales strategy, and channel leadership. Known for his execution excellence and team-building acumen, Mayank’s ability to connect authentically has made him a pioneer in appliance and gadgets networking. ",
  },

  {
    image: require("../../assets/images/About/About-Three.png"),
    name: "Atul Sharma",
    position: "Head – Technology ",
    linkedinUrl: "https://www.linkedin.com/in/atul-sharma-meta-insurance/",
    description:
      "Atul brings 12 years of rich experience across product innovation, customer engagement, and SaaS delivery. A hands-on experience in tech strategy, he’s known for building scalable B2B/B2C solutions and fostering agile transformation.",
  },
];

// Always animate right to left
const variants = {
  enter: {
    x: 300,
    opacity: 0,
  },
  center: {
    x: 0,
    opacity: 1,
  },
  exit: {
    x: -300,
    opacity: 0,
  },
};

const ProfileSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const paginate = (increment) => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex + increment + TEAMMEMBER.length) % TEAMMEMBER.length
    );
  };
  const { name, position, image, description } = TEAMMEMBER[currentIndex];

  return (
    <Box
      sx={{
        backgroundColor: "#f9f4f2",
        py: 6,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          {/* Left Arrow */}
          <IconButton
            onClick={() => paginate(-1)}
            sx={{
              // left: { xs: 40, sm: -50, md: -140, lg: -250 },
              left: { xs: 0, sm: -50, md: -140, lg: -250 },
            }}
          >
            <ArrowBackIos sx={{ color: "#FF8C00" }} />
          </IconButton>
          {/* <Button
            onClick={() => paginate(-1)}
            sx={{
              position: "absolute",
              left: -40,
              zIndex: 1,
              minWidth: 0,
              padding: 1,
            }}
          >
            <ArrowBackIos />
          </Button> */}
          {/* Animated Card */}
          <AnimatePresence mode="wait" style={{ backgroundColor: "red" }}>
            <motion.div
              key={currentIndex}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 0.5 }}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                // gap: 16,
                // padding: 24,
                borderRadius: 12,
                // backgroundColor: "#f9f4f2",
                // backgroundColor: theme.palette.background.paper,
                // boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                width: "100%",
                // width: "480px", // Increased from 100% to fixed wider size
                // width: { xs: "480px", sm: "480px", md: "480px", lg: "680px" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  // flexWrap: "wrap", // allow wrapping on smaller screens
                  // px: { xs: 2, sm: 4 },
                  // px: 4,
                  py: { xs: 0, sm: 0, md: 2, lg: 2 },
                  bgcolor: "#f9f4f2",
                  gap: 2,
                  // minHeight: "100vh",
                  flexDirection: "row", // keep horizontal layout always
                  flexWrap: "nowrap", // prevent wrapping
                  overflow: "hidden",
                }}
              >
                {/* <Box
                  sx={{
                    textAlign: "center",
                    px: { xs: 0, sm: 0, md: 5, lg: 15 },
                  }}
                >
                  <Box
                    sx={{
                      mb: 1,
                      mx: "auto",
                      width: 200,
                      height: 200,
                      overflow: "hidden",
                      borderRadius: "50%",
                      backgroundColor: "#13452b",
                      border: "4px solid transparent",
                      background: "linear-gradient(93.14deg, #FF8C00, #FF4500)",
                    }}
                  >
                    <Avatar
                      src={image}
                      alt={name}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 600,
                      color: "black",
                      fontFamily: '"Poppins",serif',
                      fontSize: { xs: "1rem", sm: "1.rem", md: "1.25rem" },
                    }}
                  >
                    {name}
                  </Typography>

                  <Typography
                    variant="subtitle1"
                    sx={{
                      mt: -0.5,
                      mb: 1,
                      color: "gray",
                      fontFamily: '"Poppins",serif',
                      fontSize: {
                        xs: "0.82rem",
                        sm: "0.82rem",
                        md: "0.9rem",
                      },
                    }}
                  >
                    {position}
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      whiteSpace: "pre-line",
                      color: "#444",
                      textAlign: "justify",
                      fontFamily: '"Poppins",serif',
                      fontSize: { xs: "0.82rem", sm: "0.82rem", md: "0.9rem" },
                      width: { xs: "310px", sm: "435px", md: "700px" },
                    }}
                  >
                    {description}
                  </Typography>
                </Box> */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    px: { xs: 0, sm: 0, md: 5, lg: 15 },
                    width: { xs: "100%", md: "700px" },
                  }}
                >
                  {/* Image + Name & Position Row */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    {/* Profile Picture */}
                    <Box
                      sx={{
                        width: { xs: 120, sm: 120, md: 150, lg: 190 },
                        height: { xs: 120, sm: 120, md: 150, lg: 190 },
                        borderRadius: "50%",
                        overflow: "hidden",
                        backgroundColor: "#13452b",
                        border: "4px solid transparent",
                        background:
                          "linear-gradient(93.14deg, #FF8C00, #FF4500)",
                        flexShrink: 0,
                      }}
                    >
                      <Avatar
                        src={image}
                        alt={name}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>

                    {/* Name and Position */}
                    <Box>
                      <Box
                        component="hr"
                        sx={{
                          width: 80,
                          height: 4,
                          background:
                            "linear-gradient(93.14deg, #FF8C00, #FF4500)",
                          border: "none",
                          my: 0, // vertical spacing
                          ml: 0, // left aligned
                          width: "100%",
                          borderRadius: 2,
                        }}
                      />

                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: "black",
                          fontFamily: '"Poppins", serif',
                          fontSize: {
                            xs: "1rem",
                            sm: "1rem",
                            md: "1.2rem",
                            lg: "1.3rem",
                          },
                        }}
                      >
                        {name}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: "gray",
                          fontFamily: '"Poppins", serif',
                          fontSize: {
                            xs: "0.8rem",
                            sm: "0.85rem",
                            md: "0.9rem",
                          },
                        }}
                      >
                        {position}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Description */}
                  <Typography
                    variant="body2"
                    sx={{
                      whiteSpace: "pre-line",
                      color: "#444",
                      textAlign: "justify",
                      fontFamily: '"Poppins", serif',
                      fontSize: { xs: "0.82rem", sm: "0.82rem", md: "0.9rem" },
                    }}
                  >
                    {description}
                  </Typography>
                </Box>
              </Box>
              {/* <Avatar
                src={TEAMMEMBER[currentIndex].image}
                alt={TEAMMEMBER[currentIndex].name}
                sx={{ width: 100, height: 100 }}
              />
              <Typography variant="h6">
                {TEAMMEMBER[currentIndex].name}
              </Typography>
              <Typography variant="subtitle1" color="textSecondary">
                {TEAMMEMBER[currentIndex].role}
              </Typography>
              <Typography variant="body1" align="center">
                {TEAMMEMBER[currentIndex].description}
              </Typography> */}
            </motion.div>
          </AnimatePresence>
          {/* Right Arrow */}

          <IconButton
            onClick={() => paginate(1)}
            sx={{ right: { xs: 0, sm: -50, md: -140, lg: -250 } }}
          >
            <ArrowForwardIos sx={{ color: "#FF8C00" }} />
          </IconButton>
          {/* <Button
            onClick={() => paginate(1)}
            sx={{
              position: "absolute",
              right: -40,
              zIndex: 1,
              minWidth: 0,
              padding: 1,
            }}
          >
            <ArrowForwardIos />
          </Button> */}
        </Box>
      </Container>
    </Box>
  );
};

export default ProfileSlider;
